import { App, Form, Input, Modal } from 'antd';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { changeMyPassword } from '../api/platform-admin';
import { useAuthStore } from '../store/auth';

export function ChangePasswordModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const logout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  const mut = useMutation({
    mutationFn: (v: { oldPassword: string; newPassword: string; confirm: string }) => {
      if (v.newPassword !== v.confirm) {
        return Promise.reject(new Error('两次输入的新密码不一致'));
      }
      return changeMyPassword(v.oldPassword, v.newPassword);
    },
    onSuccess: () => {
      message.success('密码已更新，请重新登录');
      form.resetFields();
      onClose();
      logout();
      navigate('/login', { replace: true });
    },
    onError: (e) => {
      const msg = (e as { response?: { data?: { message?: string } }; message?: string }).response?.data?.message
        ?? (e as Error).message
        ?? '修改失败';
      message.error(msg);
    },
  });

  return (
    <Modal open={open} onCancel={onClose} onOk={() => form.submit()} title="修改密码" confirmLoading={mut.isPending} destroyOnClose>
      <Form form={form} layout="vertical" onFinish={(v) => mut.mutate(v)}>
        <Form.Item name="oldPassword" label="原密码" rules={[{ required: true }]}>
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Form.Item name="newPassword" label="新密码" rules={[{ required: true, min: 8, message: '至少 8 位且含字母与数字' }]}>
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item name="confirm" label="确认新密码" rules={[{ required: true }]}>
          <Input.Password autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
}
